module.exports = __webpack_public_path__ + "04e451ad4a9d37f5e4b2a7f36b7f6ad4.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1121
// module chunks = 0